<template>
    <dashboard-layout fullHeight>
        <template slot="title">
            <v-row no-gutters align="center">
                <v-col cols="auto"> <h3 class="tit grey-c--text">근무계약서 회신내역</h3> </v-col>
                <v-col cols="auto"> <span class="tit__line" /> </v-col>
                <v-col cols="auto">
                    <h3 class="tit">{{ contract?.subject }}</h3>
                </v-col>
            </v-row>
        </template>
        <template slot="contents">
            <v-row align-md="center" class="mb-n4 mb-md-12" style="flex: 0 0 auto;">
                <v-col cols="12" class="mb-10 mb-md-0">
                    <v-badge floating dot class="v-badge--btn">
                        <v-btn text @click="$router.go(-1)">
                            <i class="icon icon-left-arrow mr-4 mr-lg-8" />
                            <h4 class="tit--sm line-height-1">상세보기</h4>
                        </v-btn>
                    </v-badge>
                </v-col>
                <v-col cols="12" class="mb-12 mb-lg-0">
                    <v-row class="ma-n8">
                        <v-col class="pa-8" cols="12" lg="6">
                            <v-row class="ma-n8">
                                <v-col class="pa-8" cols="12">
                                    <employment-contract-view-info v-model="contract" />
                                </v-col>
                                <v-col class="pa-8" cols="12">
                                    <employment-contract-view-user v-model="contract" />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="pa-8" cols="12" lg="6" v-if="contract.isSigned">
                            <employment-contract-view-logs v-model="contract" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <client-loader v-bind="{ loading }" />
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { initEmploymentContract } from "@/assets/variables";

import ClientLoader from "@/components/client/dumb/client-loader.vue";
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import EmploymentContractViewInfo from "@/components/dashboard/company/employment/contract/view/employment-contract-view-info.vue";
import EmploymentContractViewLogs from "@/components/dashboard/company/employment/contract/view/employment-contract-view-logs.vue";
import EmploymentContractViewUser from "@/components/dashboard/company/employment/contract/view/employment-contract-view-user.vue";

export default {
    components: {
        ClientLoader,
        DashboardLayout,
        EmploymentContractViewInfo,
        EmploymentContractViewLogs,
        EmploymentContractViewUser,
    },
    props: {
        _contract: { type: String, default: null },
    },
    data: () => ({
        /** @type {import('@/assets/variables').EmploymentContract} */
        contract: initEmploymentContract(),

        loading: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { contract } = await api.v1.company.employment.contracts.get({ _id: this._contract });
                this.contract = contract;
            } finally {
                this.loading = false;
            }
        },

        async remove() {
            let go = confirm("해당 근로계약서를 삭제하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.company.employment.contracts.delete({ _id: this._contract });
                alert("삭제되었습니다.");
                this.$router.replace("/dashboard/employment/contracts");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
